import { graphql } from "gatsby"
import { Box, Button, Container } from "@fastly/consistently"
import styled from "styled-components"

import RichText from "@components/rich-text/renderer"
import { setLangCookie } from "@components/navigation/menus/language-menu"
import { Head as BaseHead } from "@components/Head/Head"

import reducePageContent from "@utils/reducePageContent"
import { reduceMicrocopySet } from "@utils/reduceMicrocopy"

import "@fragments/Page"

const StyledContainer = styled(Container)`
  h1 {
    font: var(--h3);
  }
`

const LangaugeUnavailable = (props) => {
  const pageContent = reducePageContent(props.data.page)

  const heading = pageContent["4KjLsaI4XBn8kKkapNp7YR"]
  const microcopySet = pageContent["5nvWwFTJLGpvScTafAol82"]
  const labels = reduceMicrocopySet(microcopySet)

  const removeLangCookieAndRedirect = (redirectUrl) => {
    setLangCookie()
    if (window) {
      window.location.href = redirectUrl
    }
  }

  return (
    <>
      <StyledContainer py="8xl">
        <RichText body={heading.rtContent} mikan={heading.mikan} />
        <Box display="flex" gridGap="xl" flexDirection={{ _: "column", md: "row" }} mt="xl">
          {/* This is purposely not prefixed because we want to send the user to EN. */}
          <Button onClick={() => removeLangCookieAndRedirect(props.pageContext.redirectPath)}>
            {labels["access-it-in-english"]}
          </Button>
          <Button onClick={() => window && window.history.back()} variant="tertiary">
            {labels["go-back-to-the-previous-page"]}
          </Button>
        </Box>
      </StyledContainer>
    </>
  )
}

export default LangaugeUnavailable

export const query = graphql`
  query {
    page: contentfulPage(contentful_id: { eq: "5q6ehUhn7OnffHd8FuvxjV" }) {
      ...Page
    }
  }
`
export const Head = (props) => {
  return (
    <BaseHead {...props}>
      <meta name="robots" content="noindex"></meta>
    </BaseHead>
  )
}
